import { Grid } from "@material-ui/core";
import React from "react";
import { portimaCookiesPolicyUrl, portimaDisclaimerUrl, portimaPrivacyUrl } from "utils/urlProvider";
import "./footer.scss";

const Footer = (): React.ReactElement => {
    return (
        <Grid container className="footer-container">
            <div className="footer-item">
                Portima © 2022 | <a href={portimaDisclaimerUrl}>Disclaimer</a> | <a href={portimaPrivacyUrl}>Privacy</a>{" "}
                | <a href={portimaCookiesPolicyUrl}>Cookie policy</a>
            </div>
        </Grid>
    );
};

export default Footer;
